window.addEventListener('DOMContentLoaded',function(){
$(function () {
  $('#js-slider-2').slick({
    arrows: false,
    dots: false,
    speed: 1000,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 400
  });
});
$(function () {
  $('#js-slider-4').slick({
    arrows: false,
    dots: false,
    speed: 1000,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 400
  });
});
$(function () {
  $('#js-slider-5').slick({
    arrows: false,
    dots: true,
		appendDots: $('.dots-7'),
    speed: 1000,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 400
  });
});


$(function () {
  $('#js-slider-3').slick({
    arrows: false,
    dots: true,
    appendDots: $('.dots-3'),
    speed: 1000,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 400
  });
});
});
//パララックス・アニメーション
var controller=new ScrollMagic.Controller();

//アニメーション
function scrollAnim() {
	var $target=document.querySelectorAll('.jscr');

	if (!$target) {
		return;
	}

	var triggerHookNum='1';
	if (window.matchMedia('screen and (max-width: 767px)').matches) {
		triggerHookNum='1';
	}

	var controller=new ScrollMagic.Controller();
	window.addEventListener('load', function() {
		for (var i=0; i<$target.length; i++) {
			var scene=new ScrollMagic.Scene({
				triggerElement: $target[i],
				triggerHook: triggerHookNum,
				reverse: false,
				offset: 0
			})
				.setClassToggle($target[i], 'is-anime')
				.addTo(controller);
		}
	});
}

$(function() {

	//全体アニメーション
	scrollAnim();

})
